import React from 'react';
import CareerDashboard from '../components/career/CareerDashboard';

const CareerGuidance = () => {
  return <CareerDashboard />;
};

export default CareerGuidance;
